module.exports = __webpack_public_path__ + "img/drag-folder.430e70ad.svg";